import React, {memo, MutableRefObject, useContext, useEffect, useState} from "react";
import {matchPath, matchRoutes, Outlet, useLocation} from "react-router-dom";
import {Box, Button, IconButton, useMediaQuery} from "@mui/material";
import {Header} from "../components/Header/Header";
import VerticalAlignTop from "@mui/icons-material/VerticalAlignTop";
import {RouteContext} from "../routes/RouteContext";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";
import lazyHydrate from 'next-lazy-hydrate';
import {Footer} from "../components/Footer/Footer";

export const Layout = memo(({forGame} : {forGame:boolean}) => {
    const [showScrollToTopButton, setShowScrollToTopButton] = useState(false);
    const {t} = useTranslation();


    const throttle = (callbackFn: any, limit: number) => {
        let wait = false;
        return function () {
            if (!wait) {
                callbackFn();
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, limit);
            }
        }
    }
    useEffect(() => {
        // Hide or show scrollToTop Button depending on scrolling position
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollToTopButton(true);
            } else {
                setShowScrollToTopButton(false);
            }
        };
        const throttledHandleScroll = throttle(handleScroll, 25);

        window.addEventListener("scroll", throttledHandleScroll, {passive: true});

        return () => window.removeEventListener("scroll", throttledHandleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box sx={{position: 'relative', minHeight: '100vh'}}>
            <Button color="primary"
                    variant="contained"
                    onClick={scrollToTop}
                    sx={(theme) => ({
                        position: 'fixed',
                        bottom: '25px',
                        right: '20px',
                        zIndex: 999,
                        backgroundColor: `${theme.palette.primary.main}`,
                        borderRadius: '50%',
                        padding: '10px',
                        minWidth: 'auto',
                        opacity: showScrollToTopButton ? 1 : 0,
                        transition: 'opacity 300ms ease',
                        boxShadow: `0 0 0 10px ${theme.palette.primary.main}66`,
                        '&:hover': {boxShadow: `0 0 0 10px ${theme.palette.primary.main}66`}
                    })}
                    aria-label={t('Scroll to top')}>
                <VerticalAlignTop/>
            </Button>
            <Box sx={{paddingBottom: '280px', display: 'block'}}>
                {(!forGame || !mobile) && <Header/>}
                <Outlet/>
            </Box>
            <Box sx={{position: 'absolute', bottom: 0, height: '280px', width: '100%'}}>
                <Footer/>
            </Box>
        </Box>
    );
});